// Minimal attitude-indicator mark: a rounded square with a horizon line and a small
// nose triangle. The one quiet cockpit reference — everything else stays disciplined.
export default function Logo({ size = 22 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      role="img"
    >
      <rect x="1" y="1" width="22" height="22" rx="6" fill="var(--accent)" />
      <path d="M4 13.5c2.5-1.6 5-2.4 8-2.4s5.5.8 8 2.4" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M12 8.2l2 2.6h-4l2-2.6z" fill="#fff" />
    </svg>
  );
}
